/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AzureDevOpsBuildWorkItemsRequest {
    getFixupPrototypeFunction() { return AzureDevOpsBuildWorkItemsRequest.fixupPrototype; }

    static newInstance(model: Partial<AzureDevOpsBuildWorkItemsRequest>): AzureDevOpsBuildWorkItemsRequest {
        let obj = Object.assign(new AzureDevOpsBuildWorkItemsRequest(), model);
        AzureDevOpsBuildWorkItemsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AzureDevOpsBuildWorkItemsRequest>): AzureDevOpsBuildWorkItemsRequest {
        if (!model) return null;
        return AzureDevOpsBuildWorkItemsRequest.newInstance(<AzureDevOpsBuildWorkItemsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AzureDevOpsBuildWorkItemsRequest) {
        if (!obj) return;

        models.AzureDevOpsBuildWorkItemsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AzureDevOpsBuildWorkItemsRequest): boolean {
        Object.setPrototypeOf(obj, AzureDevOpsBuildWorkItemsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.build_id === undefined) {
            this.build_id = 0;
        }
    }

    /**
     * Service Account ID
     */
    service_account_id: string;

    /**
     * Azure Devops Project ID
     */
    project_id: string;

    /**
     * Azure Devops Build ID
     */
    build_id: number;

}
